/**
 * Memerle — FAQ fiche produit : un seul accordéon ouvert à la fois.
 */
(function () {
  function initProductFaq(section) {
    if (!section || section.dataset.productFaqInit === 'true') return;
    section.dataset.productFaqInit = 'true';

    const detailsList = section.querySelectorAll('.product-faq__item details');

    detailsList.forEach(function (details) {
      var summary = details.querySelector('summary');

      var syncAria = function () {
        if (summary) {
          summary.setAttribute('aria-expanded', details.open ? 'true' : 'false');
        }

        if (!details.open) return;

        detailsList.forEach(function (other) {
          if (other !== details) other.open = false;
        });
      };

      details.addEventListener('toggle', syncAria);
      if (summary) syncAria();
    });
  }

  function initAll() {
    document.querySelectorAll('[data-product-faq]').forEach(initProductFaq);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    const section = event.target.querySelector('[data-product-faq]');
    if (section) initProductFaq(section);
  });
})();
